import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import axios from "axios";
import logo from "../assets/dashboard/logo.png";
import dashboard from "../assets/dashboard/dashboard.png";
import orderlist from "../assets/dashboard/orderlist.png";
import logout from "../assets/dashboard/logout.png";
import more from "../assets/dashboard/More.png";
import bag from "../assets/dashboard/Shopping bag.png";
import customer from "../assets/dashboard/Customer.png";
import price from "../assets/dashboard/Price tag.png";
import profit from "../assets/dashboard/Profit.png";
import home from "../assets/dashboard/Home.png";
import Navbar from "../components/Navbar";

function Dashboard() {
    const [data, setData] = useState({ Orders: 0, Customers: 0, Sales: 0, Profit: 0 });
    const [customers, setCustomers] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [orders, setOrders] = useState([]);
    const [revenue, setRevenue] = useState([]);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const customerType = localStorage.getItem("CustomerType");
    const LedName = localStorage.getItem("LedName");
    const AgentCode = localStorage.getItem("AgentCode");
    const Ledcode = localStorage.getItem("Ledcode");
    const [balance, setBalance] = useState("0.00");


    const navigate = useNavigate();

    const dashboardPage = async () => {
        navigate("/dashboard");
    };

    const orderlistPage = async () => {
        navigate("/orderlist");
    };

    const Homepage = async () => {
        navigate("/home");
    };

    const logoutPage = async () => {
        navigate("/");
    };

    useEffect(() => {
        axios
            .get(
                `${apiBaseUrl}/dashboard/getTotal/JAPAN_ACCESORIES?days=30&ledcode=${encodeURIComponent(
                    Ledcode
                )}&agentCode=${encodeURIComponent(AgentCode)}`
            )
            .then((response) => {
                const result = response.data[0];
                setData({
                    Orders: result.Orders,
                    Customers: result.Customers,
                    Sales: result.Sales,
                    Profit: result.Profit,
                });
            })
            .catch((error) => {
                console.error("There was an error fetching the data!", error);
            });
    }, [apiBaseUrl, Ledcode, AgentCode]);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const response = await axios.get(
                    `${apiBaseUrl}/dashboard/TopCustomers/JAPAN_ACCESORIES?ledcode=${encodeURIComponent(
                        Ledcode
                    )}&agentCode=${encodeURIComponent(AgentCode)}`
                );
                setCustomers(response.data);
            } catch (error) {
                console.error("Error fetching the customers:", error);
            }
        };

        fetchCustomers();
    }, [apiBaseUrl, Ledcode, AgentCode]);

    useEffect(() => {
        const fetchCustomerList = async () => {
            try {
                const response = await axios.get(
                    `${apiBaseUrl}/dashboard/CustomerList/JAPAN_ACCESORIES?days=30&ledcode=${encodeURIComponent(
                        Ledcode
                    )}&agentCode=${encodeURIComponent(AgentCode)}`
                );
                setCustomerList(response.data);
            } catch (error) {
                console.error("Error fetching the customers:", error);
            }
        };

        fetchCustomerList();
    }, [apiBaseUrl, Ledcode, AgentCode]);

    useEffect(() => {
        fetch(
            `${apiBaseUrl}/dashboard/RecentOrders/JAPAN_ACCESORIES?ledcode=${encodeURIComponent(
                Ledcode
            )}&agentCode=${encodeURIComponent(AgentCode)}`
        )
            .then((response) => response.json())
            .then((data) => setOrders(data))
            .catch((error) => console.error("Error fetching data:", error));
    }, [apiBaseUrl, Ledcode, AgentCode]);

    useEffect(() => {
        const fetchRevenue = async () => {
            try {
                const response = await axios.get(
                    `${apiBaseUrl}/dashboard/OrderRevenue/JAPAN_ACCESORIES?ledcode=${encodeURIComponent(
                        Ledcode
                    )}&agentCode=${encodeURIComponent(AgentCode)}`
                );
                setRevenue(response.data);
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };

        fetchRevenue();
    }, [apiBaseUrl, Ledcode, AgentCode]);

    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const response = await fetch(
                    `${apiBaseUrl}/user/balance/JAPAN_ACCESORIES/${Ledcode}`
                );
                const data = await response.json();

                if (data.success) {
                    setBalance(data.balance); // This will set "68935.16 Dr" or similar
                }
            } catch (error) {
                console.error('Error fetching balance:', error);
            }
        };

        fetchBalance();
    }, [Ledcode, apiBaseUrl]); // Add ledCode as dependency

    return (
        <div>
            {/* navbar  */}
            {/* <div className="sticky top-0 z-50">
                <Navbar />
            </div> */}
            <div className="relative min-h-screen flex flex-row">
                <div className="fixed  top-0 left-0 w-[15%] h-[100vh] bg-[white]  flex-col py-8 px-10 gap-4 border-r-2 border-[#EEEEEE] hidden lg:flex">
                    <div className="flex justify-center items-center w-[100%] ">
                        <img src={logo} alt="logo" />
                    </div>
                    <div className="flex flex-row gap-3 mt-7 hover:bg-[#EEEEEE] p-4 rounded-full">
                        <img src={dashboard} alt="dashboard" />
                        <span
                            className="text-sm font-[600] font-display3 cursor-pointer "
                            onClick={dashboardPage}
                        >
                            Dashboard
                        </span>
                    </div>
                    <div className="flex flex-row gap-3  hover:bg-[#EEEEEE] p-4 rounded-full">
                        <img src={orderlist} alt="orderlist" />
                        <span
                            className="text-sm font-[600] font-display3 cursor-pointer "
                            onClick={orderlistPage}
                        >
                            Order List
                        </span>
                    </div>
                    <div className="flex flex-row gap-3  hover:bg-[#EEEEEE] p-4 rounded-full">
                        <img src={home} alt="orderlist" />
                        <span
                            className="text-sm font-[600] font-display3 cursor-pointer "
                            onClick={Homepage}
                        >
                            Home
                        </span>
                    </div>
                    <div className="flex flex-row gap-3  hover:bg-[#EEEEEE] p-4 rounded-full">
                        <img src={logout} alt="logout" />
                        <span
                            className="text-sm font-[600] font-display3 cursor-pointer "
                            onClick={logoutPage}
                        >
                            Logout
                        </span>
                    </div>
                </div>

                <div className="lg:ml-[15%] lg:w-[85%] w-[100%] flex flex-col mt-[10.526315789473685vh]">
                    <div className="fixed lg:ml-[15%] top-0 left-0 border-b-2 border-[#EEEEEE] lg:w-[85%] w-[100%] h-[10.526315789473685vh] bg-[white] flex lg:justify-end justify-between items-center lg:px-5 px-2 gap-5 z-50">
                        <div className="flex flex-row    lg:hidden  h-[100%]  gap-2">
                            <div className=" flex flex-row  items-center gap-[2%] ">
                                <img src={logo} alt="logo" style={{ height: "70%" }} />
                            </div>
                        </div>
                        <div className="flex flex-row gap-6 lg:hidden ">
                            <img
                                src={dashboard}
                                alt="dashboard"
                                className="cursor-pointer hover:bg-[#EEEEEE]"
                                onClick={dashboardPage}
                            />
                            <img
                                src={orderlist}
                                alt="orderlist"
                                className="cursor-pointer hover:bg-[#EEEEEE]"
                                onClick={orderlistPage}
                            />
                            <img
                                src={home}
                                alt="orderlist"
                                className="cursor-pointer hover:bg-[#EEEEEE]"
                                onClick={Homepage}
                            />
                            <img
                                src={logout}
                                alt="logout"
                                className="cursor-pointer hover:bg-[#EEEEEE]"
                                onClick={logoutPage}
                            />
                        </div>
                        <div className="flex flex-row gap-2 ">
                            <div className="border lg:h-[25px] lg:w-[23px] h-[20px] w-[15px] border-[#ABABAB] flex justify-center items-center  rounded-[50%]">
                                <img src={more} alt="more" style={{ width: "50%", height: "50%" }} />
                            </div>
                            <span className="lg:text-base md:text-sm text-xs font-[700] font-display3 mr-8">{LedName}</span>
                        </div>
                    </div>

                    <div className="w-[100%] h-auto lg:px-5 px-2 bg-[#F5F6FA] py-5 gap-5">
                        <span className="lg:text-3xl text-2xl font-[700] font-display3">Dashboard</span>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full mt-5">
                            <div className="w-[100%] h-[161px] rounded-[15px] bg-[white] px-2 py-3 flex flex-row">
                                <div className="w-[60%] bg-[] flex flex-col gap-5 justify-center items-center">
                                    <span className="lg:text-base md:text-sm text-xs font-[600] font-display3">
                                        Total Orders
                                    </span>
                                    <span className="lg:text-2xl md:text-xl text-lg  font-[700] font-display3">
                                        {data.Orders}
                                    </span>
                                    <span className="text-[11px] md:text-xs text-gray-500 font-display3">
                                         This month’s orders
                                    </span>
                                </div>
                                <div className="w-[40%]  flex justify-center items-center">
                                    <div className="lg:w-[60px] lg:h-[60px] md:w-[55px] md:h-[55px] w-[50px] h-[50px] rounded-[45%] bg-[#8B0000] flex justify-center items-center">
                                        <img src={bag} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="w-[100%] h-[161px] rounded-[15px] bg-[white] px-2 py-3 flex flex-row">
                                <div className="w-[60%]  flex flex-col gap-5 justify-center items-center">
                                    <span className="lg:text-base md:text-sm text-xs font-[600] font-display3">
                                        Total Customers
                                    </span>
                                    <span className="lg:text-2xl md:text-xl text-lg font-[700] font-display3">
                                        {data.Customers}
                                    </span>
                                    <span className="text-[11px] md:text-xs text-gray-500 font-display3">
                                         This month’s Customers
                                    </span>
                                </div>
                                <div className="w-[40%]  flex justify-center items-center">
                                    <div className="lg:w-[60px] lg:h-[60px] md:w-[55px] md:h-[55px] w-[50px] h-[50px] rounded-[45%] bg-[#8B0000] flex justify-center items-center">
                                        <img src={customer} alt="customer" />
                                    </div>
                                </div>
                            </div>
                            <div className="w-[100%] h-[161px] rounded-[15px] bg-[white] px-2 py-3 flex flex-row">
                                <div className="w-[60%]  flex flex-col gap-5 justify-center items-center">
                                    <span className="lg:text-base md:text-sm text-xs font-[600] font-display3">
                                        Total Sales
                                    </span>
                                    <span className="lg:text-2xl md:text-xl text-lg font-[700] font-display3">
                                        {data.Sales}
                                    </span>
                                    <span className="text-[11px] md:text-xs text-gray-500 font-display3">
                                         This month’s Sales
                                    </span>
                                </div>
                                <div className="w-[40%]  flex justify-center items-center">
                                    <div className="lg:w-[60px] lg:h-[60px] md:w-[55px] md:h-[55px] w-[50px] h-[50px] rounded-[45%] bg-[#8B0000] flex justify-center items-center">
                                        <img src={price} alt="price" />
                                    </div>
                                </div>
                            </div>
                            {(customerType === "DEALER" || customerType === "CUSTOMER") && (
                                <div className="w-[100%] h-[161px] rounded-[15px] bg-[white] px-2 py-3 flex flex-row">
                                    <div className="w-[60%]  flex flex-col gap-5 justify-center items-center">
                                        <span className="lg:text-base md:text-sm text-xs font-[600] font-display3">
                                            Current Balance
                                        </span>
                                        <span className="lg:text-2xl md:text-xl text-lg font-[700] font-display3">
                                            {balance}
                                        </span>
                                    </div>
                                    <div className="w-[40%]  flex justify-center items-center">
                                        <div className="lg:w-[60px] lg:h-[60px] md:w-[55px] md:h-[55px] w-[50px] h-[50px] rounded-[45%] bg-[#8B0000] flex justify-center items-center">
                                            <img src={profit} alt="price" />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {customerType !== "DEALER" && (
                                <div className="w-[100%] h-[161px] rounded-[15px] bg-[white] px-2 py-3 flex flex-row">
                                    <div className="w-[60%]  flex flex-col gap-5 justify-center items-center">
                                        <span className="lg:text-base md:text-sm text-xs font-[600] font-display3">
                                            Total Profit
                                        </span>
                                        <span className="lg:text-2xl md:text-xl text-lg font-[700] font-display3">
                                            {data.Profit}
                                        </span>
                                        <span className="text-[11px] md:text-xs text-gray-500 font-display3">
                                             This month’s Profit
                                        </span>
                                    </div>
                                    <div className="w-[40%]  flex justify-center items-center">
                                        <div className="lg:w-[60px] lg:h-[60px] md:w-[55px] md:h-[55px] w-[50px] h-[50px] rounded-[45%] bg-[#8B0000] flex justify-center items-center">
                                            <img src={profit} alt="profit" />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="flex lg:flex-row flex-col gap-4 mt-5">
                            <div className="h-[331px] lg:w-[70%] w-[100%] bg-[white] rounded-[15px] flex flex-col px-6 py-2 gap-5">
                                <div className="lg:text-xl text-lg font-[700] font-display3 h-[10%] w-full ">
                                    Order Revenue
                                </div>
                                <div className="h-[90%] w-full ">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart data={revenue} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="DDate" className="text-sm font-[500] font-display3" />
                                            <YAxis className="text-sm font-[500] font-display3" />
                                            <Tooltip className="text-sm font-[500] font-display3" />
                                            <Legend className="text-sm font-[500] font-display3" />
                                            <Bar dataKey="Profit" fill="#8B0000" barSize={30} radius={[20, 20, 0, 0]} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                            <div className="h-[331px] lg:w-[30%] w-[100%] bg-[white] rounded-[15px] flex flex-col px-6 py-2 gap-5">
                                <div className="lg:text-xl text-lg font-[700] font-display3 h-[10%] w-full">
                                    Top Customers
                                </div>
                                <div className="flex-1 w-full overflow-y-auto">
                                    <div className="flex flex-col gap-3">
                                        {customers.map((customer, index) => (
                                            <div
                                                key={index}
                                                className="text-base font-[400] font-display3 flex flex-row gap-8"
                                            >
                                                <span className="text-base font-[700] font-display3">{index + 1}.</span>{" "}
                                                {customer.Name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex lg:flex-row flex-col gap-4 mt-5">
                            <div className="h-[331px] lg:w-[70%] w-[100%] bg-[white] rounded-[15px] flex flex-col px-6 py-2 gap-5">
                                <div className="lg:text-xl text-lg font-[700] font-display3 h-[10%] w-full">
                                    Recent Orders
                                </div>
                                <div className="flex-1 w-full overflow-y-auto">
                                    <div className="h-[10%] w-full flex flex-row border-b border-[#EEEEEE]">
                                        <div className="w-[20%]">
                                            <div className="text-sm font-[700] font-display3 text-[#ABABAB]">No</div>
                                        </div>
                                        <div className="w-[40%]">
                                            <div className="text-sm font-[700] font-display3 text-[#ABABAB]">Title</div>
                                        </div>
                                        <div className="w-[20%]">
                                            <div className="text-sm font-[700] font-display3 text-[#ABABAB]">Quantity</div>
                                        </div>
                                        <div className="w-[20%]">
                                            <div className="text-sm font-[700] font-display3 text-[#ABABAB]">Price</div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-3 mt-5">
                                        {orders.map((order, index) => (
                                            <div key={index} className="w-full flex flex-row gap-3">
                                                <div className="w-[20%]">
                                                    <div className="text-base font-[600] font-display3">{index + 1}</div>
                                                </div>
                                                <div className="w-[40%]">
                                                    <div className="text-base font-[600] font-[nunito sans]">
                                                        {order.Title}
                                                    </div>
                                                </div>
                                                <div className="w-[20%]">
                                                    <div className="text-base font-[600] font-[nunito sans] px-5">
                                                        {order.Qty}
                                                    </div>
                                                </div>
                                                <div className="w-[20%]">
                                                    <div className="text-base font-[600] font-[nunito sans]">
                                                        {order.Price}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="h-[331px] lg:w-[30%] w-[100%] bg-[white] rounded-[15px] flex flex-col px-6 py-2 gap-5">
                                <div className="lg:text-xl text-lg font-[700] font-[nunito sans] h-[10%] w-full">
                                    Customers
                                </div>
                                <div className="flex-1 w-full overflow-y-auto">
                                    <div className="flex flex-col gap-3">
                                        {customerList.map((customer, index) => (
                                            <div
                                                key={index}
                                                className="text-base font-[400] font-[nunito sans] flex flex-row gap-8"
                                            >
                                                <span className="text-base font-[700] font-[nunito sans]">
                                                    {index + 1}.
                                                </span>{" "}
                                                {customer.Customer}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
